import { SVGProps } from '@components/Icon/types';

export const LogOut = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 16 15"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      d="M7.9751 13.7292H2.36876C2.0249 13.7292 1.74585 13.4502 1.74585 13.1063V1.89369C1.74585 1.54983 2.02493 1.27078 2.36876 1.27078H7.9751C8.31957 1.27078 8.59801 0.992344 8.59801 0.647871C8.59801 0.303398 8.31957 0.0249023 7.9751 0.0249023H2.36876C1.33845 0.0249023 0.5 0.863379 0.5 1.89369V13.1063C0.5 14.1366 1.33845 14.9751 2.36876 14.9751H7.9751C8.31957 14.9751 8.59801 14.6966 8.59801 14.3522C8.59801 14.0077 8.31957 13.7292 7.9751 13.7292Z"
      fill={fill}
    />
    <path
      d="M15.3144 7.05653L11.527 3.31898C11.2828 3.07729 10.8879 3.08042 10.6462 3.32522C10.4045 3.57003 10.407 3.96434 10.6524 4.20604L13.359 6.87712H6.10631C5.76184 6.87712 5.4834 7.15556 5.4834 7.50003C5.4834 7.8445 5.76184 8.12297 6.10631 8.12297H13.359L10.6524 10.7941C10.407 11.0358 10.4051 11.4301 10.6462 11.6749C10.7683 11.7982 10.929 11.8605 11.0897 11.8605C11.2479 11.8605 11.4061 11.8007 11.527 11.6811L15.3144 7.94353C15.4327 7.82643 15.5 7.66693 15.5 7.5C15.5 7.33313 15.4333 7.17428 15.3144 7.05653Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'log-out';
